import React from 'react'

export const IconHomes = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M0.875 6.94914L6.21865 2.79297L11.5623 6.94914V13.4803C11.5623 13.7952 11.4372 14.0972 11.2145 14.3199C10.9918 14.5426 10.6898 14.6677 10.3748 14.6677H2.06248C1.74754 14.6677 1.4455 14.5426 1.2228 14.3199C1.00011 14.0972 0.875 13.7952 0.875 13.4803V6.94914Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.5619 11.4998H14.2007C14.4457 11.4998 14.6806 11.3997 14.8538 11.2216C15.027 11.0434 15.1243 10.8018 15.1243 10.5498V5.32494L10.9682 2L8.15723 4.24875"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.4375 14.6679V8.73047H7.99993V14.6679"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
